<template>
  <div class="form-container">
    <h2>MEMBER FORM</h2>
    <v-card outlined class="form-card mt-2">
      <v-card-title class="py-2">
        Member Info
      </v-card-title>
      <v-divider />
      <v-card-text class="pa-4">
        <div>
          <v-form v-model="form.valid">
            <v-row>
              <v-col cols="6">
                <Label text="Company" required>
                  <CompanySelect :company-id="companyId" :co-seq.sync="form.cmCoSeq" :rules="rules.company" readonly />
                </Label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <Label text="UserID or Email" required>
                  <v-text-field v-model="form.userId" :rules="rules.userId" />
                </Label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <Label text="User Role" required>
                  <UserRoleSelect v-model="form.role" :rules="rules.userRole" />
                </Label>
              </v-col>
            </v-row>
          </v-form>
        </div>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn color="error darken-1" outlined :loading="loading" @click="cancel">
          Cancel
        </v-btn>
        <v-btn color="blue darken-1" outlined :loading="loading" :disabled="!form.valid" @click="save">
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { useMemberForm } from '../composition/useMemberForm'
import { saveCompanyMember } from '@/api/company/companyMemberApi'

export default defineComponent({
  name: 'MemberAddForm',
  components: {
    Label: () => import('@/components/form/Label/index.vue'),
    CompanySelect: () => import('@/components/form/CompanySelector.vue'),
    UserRoleSelect: () => import('@/components/form/UserRoleSelector.vue')
  },
  setup(props) {
    const root = getCurrentInstance().proxy
    const companyId = computed(() => root.$route.params.companyId)
    const { form, rules, loading, save } = useMemberForm(saveCompanyMember)

    return {
      companyId,
      form, rules, loading,
      save() {
        save().then(() => {
          root.$router.push({ name: 'CompanyDetail', params: { companyId }})
        })
      },
      cancel() {
        root.$router.go(-1)
      }
    }
  }
})
</script>

<style scoped lang="scss">

</style>
